export class UserLoginResponse {
  public successful: boolean = false;
  public message: string = "";
  public login_token: string = "";
  public email_id: string = "";
  public post_id: number = 0;
  public under_supervision_post_ref: number = 0;
  public role: number = 0;
  public role_name: string = "";
  public phone_nos: string = "";
  public user_display_name: string = "";
  public to_date: string = "";
  // public ValidMenuItemIds2: string[] = [];
  // public LastSelectedChapterRef: number = 0;
  // public LastSelectedChapterName: string = "";
  // public LastSelectedSubChapterRef: number = 0;
  // public LastSelectedSubChapterName: string = "";
  // public ChapterRef: number = 0;
  // public SubChapterRef: number = 0;
  public login_user_id: number = 0;
  public first_login_completed: number = 0;
  public short_name: string = "";
  public financial_year_responses: any[] = [];
  public months: number[] = [];
  public valid_web_menu_item_ids : MenuPermissionDto[] = [];
  public language_preference: number = 0;

  public phc_name_en: string = "";
  public phc_name_mr: string = "";
  public sc_name_en: string = "";
  public sc_name_mr: string = "";
  public village_name_en: string = "";
  public village_name_mr: string = "";

  public user_display_name_en : string = "";
  public user_display_name_mr : string = "";
  public role_name_en: string = "";
  public role_name_mr: string = "";

}
export class MenuPermissionDto {
  public menu_id: string = "";
  public can_add: boolean = false;
  public can_view: boolean = false;
  public can_edit: boolean = false;
  public can_delete: boolean = false;
  public can_export: boolean = false;
}
